import type { PropsWithChildren } from 'react';

type ChapterTitleProps = PropsWithChildren;

const ChapterTitle = ({ children }: ChapterTitleProps) => (
    <div className='text-size-h2 text-medium margin-bottom-15'>{children}</div>
);

export default ChapterTitle;
